import { StylePropertyDefinition } from '../../types/common';
export const styleProperties: Array<StylePropertyDefinition> = [];
export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [
	{
		cp: 'cursor',
		sel: '.comp.compButtonBar ._button',
		np: true,
		gn: 'Cursor',
		dn: 'Cursor Button',
		n: 'buttonBarCursorButton',
		dv: 'pointer',
	},
	{
		cp: 'gap',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme>',
		np: true,
		spv: {
			'_buttonBarDesign3-': '2px',
			'_buttonBarDesign4-': '2px',
		},
		gn: 'Gap',
		dn: 'Gap',
		n: 'buttonBarGap<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme>',
		np: true,
		gn: 'Border',
		dn: 'Border',
		n: 'buttonBarBorder<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme>',
		np: true,
		spv: {
			'_buttonBarDesign2-': '30px',
			'_buttonBarDesign3-': '30px',
			'_buttonBarDesign4-': '40px',
		},
		gn: 'Border Radius',
		dn: 'BorderRadius',
		n: 'buttonBarBorderRadius<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		spv: {
			'_buttonBarDesign4-_primary': '<backgroundColorOne>',
			'_buttonBarDesign4-_secondary': '<backgroundColorTwo>',
			'_buttonBarDesign4-_tertiary': '<backgroundColorThree>',
			'_buttonBarDesign4-_quaternary': '<backgroundColorFour>',
			'_buttonBarDesign4-_quinary': '<backgroundColorFive>',
			'_buttonBarDesign1-': '<fontColorTwo>',
			'_buttonBarDesign2-': '<fontColorTwo>',
			'_buttonBarDesign3-': '<fontColorTwo>',
		},
		gn: 'Color',
		dn: 'Color Button',
		n: 'buttonBarColorButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		spv: {
			'_buttonBarDesign1-': 'none',
			'_buttonBarDesign2-': 'none',
			'_buttonBarDesign3-': 'none',
			'_buttonBarDesign4-': 'none',
		},
		gn: 'Border',
		dn: 'Border Button',
		n: 'buttonBarBorderButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-top',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Top',
		dn: 'BorderTop Button',
		n: 'buttonBarBorderTopButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-right',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Right',
		dn: 'BorderRight Button',
		n: 'buttonBarBorderRightButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Bottom',
		dn: 'BorderBottom Button',
		n: 'buttonBarBorderBottomButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-left',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Left',
		dn: 'BorderLeft Button',
		n: 'buttonBarBorderLeftButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-top-left-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Top Left Radius',
		dn: 'BorderTopLeftRadius Button',
		n: 'buttonBarBorderTopLeftRadiusButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom-left-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Bottom Left Radius',
		dn: 'BorderBottomLeftRadius Button',
		n: 'buttonBarBorderBottomLeftRadiusButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom-right-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Bottom Right Radius',
		dn: 'BorderBottomRightRadius Button',
		n: 'buttonBarBorderBottomRightRadiusButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-top-right-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		gn: 'Border Top Right Radius',
		dn: 'BorderTopRightRadius Button',
		n: 'buttonBarBorderTopRightRadiusButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		spv: {
			'_buttonBarDesign3-': '30px',
			'_buttonBarDesign4-': '40px',
		},
		gn: 'Border Radius',
		dn: 'BorderRadius Button',
		n: 'buttonBarBorderRadiusButton<buttonBarDesign><colorScheme>',
	},

	{
		cp: 'height',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		dv: '32px',
		gn: 'Height',
		dn: 'Height Button',
		n: 'buttonBarHeightButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button',
		np: true,
		spv: {
			'_buttonBarDesign1-_primary': '<backgroundColorOne>',
			'_buttonBarDesign1-_secondary': '<backgroundColorTwo>',
			'_buttonBarDesign1-_tertiary': '<backgroundColorThree>',
			'_buttonBarDesign1-_quaternary': '<backgroundColorFour>',
			'_buttonBarDesign1-_quinary': '<backgroundColorFive>',
			'_buttonBarDesign2-_primary': '<backgroundColorOne>',
			'_buttonBarDesign2-_secondary': '<backgroundColorTwo>',
			'_buttonBarDesign2-_tertiary': '<backgroundColorThree>',
			'_buttonBarDesign2-_quaternary': '<backgroundColorFour>',
			'_buttonBarDesign2-_quinary': '<backgroundColorFive>',
			'_buttonBarDesign3-_primary': '<backgroundColorOne>',
			'_buttonBarDesign3-_secondary': '<backgroundColorTwo>',
			'_buttonBarDesign3-_tertiary': '<backgroundColorThree>',
			'_buttonBarDesign3-_quaternary': '<backgroundColorFour>',
			'_buttonBarDesign3-_quinary': '<backgroundColorFive>',
			'_buttonBarDesign4-': '<backgroundColorTen>',
		},
		gn: 'Background',
		dn: 'Background Button',
		n: 'buttonBarBackgroundButton<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button:hover',
		np: true,
		spv: {
			'_buttonBarDesign1-': '<fontColorOne>',
			'_buttonBarDesign4-': '<fontColorEight>',
		},
		gn: 'Color',
		dn: 'Color Buttonhover',
		n: 'buttonBarColorButtonhover<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button:hover, .comp.compButtonBar<buttonBarDesign><colorScheme> ._button._selected',
		np: true,
		spv: {
			'_buttonBarDesign1-_primary': '<backgroundHoverColorOne>',
			'_buttonBarDesign1-_secondary': '<backgroundHoverColorTwo>',
			'_buttonBarDesign1-_tertiary': '<backgroundHoverColorThree>',
			'_buttonBarDesign1-_quaternary': '<backgroundHoverColorFour>',
			'_buttonBarDesign1-_quinary': '<backgroundHoverColorFive>',
			'_buttonBarDesign2-_primary': '<backgroundHoverColorOne>',
			'_buttonBarDesign2-_secondary': '<backgroundHoverColorTwo>',
			'_buttonBarDesign2-_tertiary': '<backgroundHoverColorThree>',
			'_buttonBarDesign2-_quaternary': '<backgroundHoverColorFour>',
			'_buttonBarDesign2-_quinary': '<backgroundHoverColorFive>',
			'_buttonBarDesign3-_primary': '<backgroundHoverColorOne>',
			'_buttonBarDesign3-_secondary': '<backgroundHoverColorTwo>',
			'_buttonBarDesign3-_tertiary': '<backgroundHoverColorThree>',
			'_buttonBarDesign3-_quaternary': '<backgroundHoverColorFour>',
			'_buttonBarDesign3-_quinary': '<backgroundHoverColorFive>',
		},
		gn: 'Background',
		dn: 'Background Selected',
		n: 'buttonBarBackgroundSelected<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom-left-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._first-child',
		np: true,
		gn: 'Border Bottom Left Radius',
		dn: 'BorderBottomLeftRadius Firstchild',
		n: 'buttonBarBorderBottomLeftRadiusFirstchild<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-top-left-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._firstChild',
		np: true,
		spv: {
			'_buttonBarDesign2-': '16px',
		},
		gn: 'Border Top Left Radius',
		dn: 'BorderTopLeftRadius FirstChild',
		n: 'buttonBarBorderTopLeftRadiusFirstChild<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom-left-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._firstChild',
		np: true,
		spv: {
			'_buttonBarDesign2-': '16px',
		},
		gn: 'Border Bottom Left Radius',
		dn: 'BorderBottomLeftRadius FirstChild',
		n: 'buttonBarBorderBottomLeftRadiusFirstChild<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-bottom-right-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._lastChild',
		np: true,
		spv: {
			'_buttonBarDesign2-': '16px',
		},
		gn: 'Border Bottom Right Radius',
		dn: 'BorderBottomRightRadius LastChild',
		n: 'buttonBarBorderBottomRightRadiusLastChild<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'border-top-right-radius',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._lastChild',
		np: true,
		spv: {
			'_buttonBarDesign2-': '16px',
		},
		gn: 'Border Top Right Radius',
		dn: 'BorderTopRightRadius LastChild',
		n: 'buttonBarBorderTopRightRadiusLastChild<buttonBarDesign><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compButtonBar<buttonBarDesign><colorScheme> ._button._selected',
		np: true,
		spv: {
			'_buttonBarDesign1-': '<fontColorOne>',
			'_buttonBarDesign4-': '<fontColorEight>',
		},
		gn: 'Color',
		dn: 'Color Selected',
		n: 'buttonBarColorSelected<buttonBarDesign><colorScheme>',
	},
];
